<div [class.form-center]="center" [class.form-fill]="!center">
	<mat-card class="form-card">
		<mat-card-content>
			<ng-content></ng-content>
		</mat-card-content>
	</mat-card>
</div>
